import { all, call, put, takeLatest } from 'redux-saga/effects';
import {
    postLegalAuthorization,
    postLegalAuthorizationSuccess,
    postLegalAuthorizationError
} from './legalActions';
import {
    LEGAL_AUTHORIZATION,
} from './actionTypes';
import { LEGAL_AUTH } from '../../../utils/urls';
import { fetchPost } from '../../../utils/request';

function* legalAuth(data: any): any {
    let body = {
        authorization_letter: data.value.autLetter,
        rbi_compliances: data.value.rbiCompliance
    }
    try {
        const resp = yield call(fetchPost, LEGAL_AUTH, body);
        if (resp.error) {
            yield put(postLegalAuthorizationError(resp.error.message));
            return false;
        }
        yield put(postLegalAuthorizationSuccess(resp.results));
        return true;
    } catch (error) {
        yield put(postLegalAuthorizationError(error));
    }
}

export default function* legalSaga() {
    yield all([takeLatest(LEGAL_AUTHORIZATION, legalAuth)])
}